export const STATE_FAVORITED_FIRST_PRO_KEY = 'favorited_first_pro';
export const STATE_DISMISSED_FAVORITE_NOTIFICATION_BUBBLE_KEY = 'favorited_first_pro_dismissed_tooltip';
export const STATE_VISITED_HOME_KEY = 'favorited_first_pro_visited_home';
